/* eslint-disable no-redeclare */
import { HealthcareSessionId, HealthcareUserId } from '@hc-frontend/core-types';
import { z } from 'zod';

export const CleanProspectBaseDto = z
  .object({
    sessionId: HealthcareSessionId,
    userId: HealthcareUserId,
    skippableProperties: z.array(z.string()),
    skippableAdditionalQuestions: z.array(z.string()),
  })
  .partial()
  .required({
    sessionId: true,
    userId: true,
  });

export type CleanProspectBaseDto = z.infer<typeof CleanProspectBaseDto>;

export const CleanProspectDto = CleanProspectBaseDto.required({
  userId: true,
  sessionId: true,
});

export type CleanProspectDto = z.infer<typeof CleanProspectDto>;
